import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import * as React from "react";
import { Box, Icon, Typography, RaiseColors } from "client/componentLibrary";
import numberWithCommas from "core/Utils/numberWithCommas";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Pagination = function Pagination(_ref) {
  var _context, _context2, _context3;
  var page = _ref.page,
    itemsPerPage = _ref.itemsPerPage,
    totalPossibleCount = _ref.totalPossibleCount,
    onChangePage = _ref.onChangePage,
    itemType = _ref.itemType,
    customPaginationText = _ref.customPaginationText;
  var currentPage = Math.max(page, 0);
  totalPossibleCount = Math.max(totalPossibleCount, 0);
  var currentlyViewingItemEnd = totalPossibleCount > 0 ? Math.min((currentPage + 1) * itemsPerPage, totalPossibleCount) : 0;
  var currentlyViewingItemStart = totalPossibleCount > 0 ? Math.min(currentPage * itemsPerPage + 1, totalPossibleCount) : 0;
  var totalPages = totalPossibleCount > 0 ? Math.ceil(totalPossibleCount / itemsPerPage - 1) : 0;
  var paginationText = customPaginationText ? customPaginationText : _concatInstanceProperty(_context = _concatInstanceProperty(_context2 = _concatInstanceProperty(_context3 = "".concat(currentlyViewingItemStart, "-")).call(_context3, currentlyViewingItemEnd, " of ")).call(_context2, numberWithCommas(totalPossibleCount), " ")).call(_context, itemType);
  var handlePreviousButtonClick = function handlePreviousButtonClick(event) {
    onChangePage(event, page - 1);
  };
  var handleNextButtonClick = function handleNextButtonClick(event) {
    onChangePage(event, page + 1);
  };
  return /*#__PURE__*/_jsxs(Box, {
    display: "flex",
    justifyContent: "center",
    alignItems: "baseline",
    children: [/*#__PURE__*/_jsxs(Box, {
      display: "flex",
      alignItems: "center"
      // Uses visibility to maintain layout of component. We want current page text to be centered
      // https://github.com/HelloOffice/dealroom/pull/2897#discussion_r517571280
      ,
      style: {
        cursor: "pointer",
        visibility: page === 0 ? "hidden" : "visible"
      },
      onClick: handlePreviousButtonClick,
      children: [/*#__PURE__*/_jsx(Icon, {
        className: "far fa-arrow-left",
        fontSize: 14,
        color: RaiseColors.black
      }), /*#__PURE__*/_jsx(Typography, {
        variant: "paragraph_small",
        weight: "semibold",
        color: RaiseColors.black,
        style: {
          marginLeft: 8,
          marginRight: 24
        },
        children: "Previous"
      })]
    }), /*#__PURE__*/_jsx(Typography, {
      variant: "paragraph_small",
      color: RaiseColors.black,
      children: paginationText
    }), /*#__PURE__*/_jsxs(Box, {
      display: "flex",
      alignItems: "center",
      style: {
        cursor: "pointer",
        // Uses visibility to maintain layout of component. We want current page text to be centered
        // https://github.com/HelloOffice/dealroom/pull/2897#discussion_r517571280
        visibility: page === totalPages ? "hidden" : "visible"
      },
      onClick: handleNextButtonClick,
      children: [/*#__PURE__*/_jsx(Typography, {
        variant: "paragraph_small",
        weight: "semibold",
        color: RaiseColors.black,
        style: {
          marginRight: 8,
          marginLeft: 24
        },
        children: "Next"
      }), /*#__PURE__*/_jsx(Icon, {
        className: "far fa-arrow-right",
        fontSize: 14,
        color: RaiseColors.black
      })]
    })]
  });
};
export default Pagination;